export default __webpack_public_path__ + "static/media/article 4.ef979a17.png";